<template>
  <div class="LoginTab">
    <div v-if="activeIndex === 0">
      <MobileLogin
        :isLock="isLock"
        :mobile="mobile"
        :separate="true"
        @login="mobileLogin"
        @getCachePhone="getCachePhone"
        :getSendPicCode="getSendPicCode"
      ></MobileLogin>
    </div>
    <div v-else>
      <PasswordLogin
        :isLock="isLock"
        :mobile="mobile"
        @login="passwordLogin"
        @getCachePhone="getCachePhone"
      ></PasswordLogin>
    </div>
    <div
      class="tabTip"
      @click="
        () => {
          headleClick(0);
        }
      "
      v-if="activeIndex !== 0"
    >
      短信验证码登录
    </div>
    <div
      class="tabTip"
      @click="
        () => {
          headleClick(1);
        }
      "
      v-else-if="activeIndex === 0 && !isLock"
    >
      密码登录
    </div>
    <CodePopup
      title="请输入验证码"
      @getInputPicVal="getInputPicVal"
      @define="define"
      @sendPicCode="sendPicCode"
      @close="close"
      :imgUrl="imgUrl"
      :value="isShow"
      :isShow="isShow"
    ></CodePopup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CodePopup from './CodePopup.vue';
import MobileLogin from './MobileLogin.vue';
import PasswordLogin from './PasswordLogin.vue';

export default {
  name: 'LoginTab',
  data() {
    return {
      tabList: ['验证码登录', '密码登录'],
      ShowContent: '',
      activeIndex: 0,
      mobile: '',
      isLock: '',
      isShow: false,
      imgUrl: '',
      inputPicVal: '',
      unencryptedPhone: '',
      codeType: '1',
      pathname: localStorage.getItem('pathname'),
    };
  },
  components: {
    CodePopup,
    MobileLogin,
    PasswordLogin,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.getPhone();
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    onCancel() { },
    getSendPicCode() {
      this.codeType = '1';
      this.sendPicCode();
    },
    getCachePhone(val) {
      this.mobile = val;
    },
    sendPicCode() {
      this.isShow = true;
      this.$api.PublicPage.getVerify({
        phone: this.mobile,
        type: this.codeType,
      })
        .then((res) => {
          let str = '';
          if (res.success) {
            if (res.data.type === 'png') {
              str = `data:image/png;base64,${res.data.file}`;
            } else {
              str = `data:image/jpg;base64,${res.data.file}`;
            }
          }
          this.imgUrl = str;
        })
        .catch(() => { });
    },
    define(obj) {
      if (obj.value) {
        this.loginVerify();
      }
    },
    close() {
      this.isShow = false;
    },
    loginVerify() {
      this.$api.PublicPage.loginVerify({
        phone: this.mobile,
        type: this.codeType,
        captcha: this.inputPicVal,
      }).then((res) => {
        if (!res.success) {
          this.$toast(res.returnMessage);
        }else{
          this.isShow = false;
        }
      });
    },

    getInputPicVal(val) {
      this.inputPicVal = val;
    },
    headleClick(index) {
      this.activeIndex = index;
    },
    getPhone() {
      this.$api.PublicPage.getLoginPhone().then((res) => {
        console.log('我请求getLoginPhone的值后======', res);
        console.log('res.data.isLock========', res.data.isLock);
        console.log('res.data.mobile========', res.data.mobile);
        this.isLock = res.data.isLock;
        this.mobile = res.data.mobile;
      });
    },
    passwordLogin(obj) {
      this.unencryptedPhone = obj.unencryptedPhone;
      this.codeType = '2';
      // eslint-disable-next-line no-param-reassign
      delete obj.unencryptedPhone;
      this.$toast.loading({
        message: '登录中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.login(obj)
        .then((res) => {
          this.$toast.clear();
          if (res.success) {
            this.$toast.success('登录成功');
            window.location.href = res.data.jumpUrl;
          } else if (res.returnCode === '30010') {
            this.sendPicCode();
          } else {
            this.$toast.fail({
              message: res.returnMessage,
              forbidClick: true,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$toast.fail(e);
        });
    },
    mobileLogin(obj) {
      this.unencryptedPhone = obj.unencryptedPhone;
      this.codeType = '1';
      // eslint-disable-next-line no-param-reassign
      delete obj.unencryptedPhone;
      this.$toast.loading({
        message: '登录中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.loginCaptcha(obj)
        .then((res) => {
          this.$toast.clear();
          if (res.success) {
            this.$toast.success('登录成功');
            window.location.href = res.data.jumpUrl;
          } else if (res.returnCode === '30010') {
            this.sendPicCode();
          } else {
            this.$toast.fail({
              message: res.returnMessage,
              forbidClick: true,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$toast.fail(e);
        });
    },
  },
};
</script>
<style scoped>
.tab-title {
  display: block;
  width: 150px;
  height: 40px;
  text-align: center;
  flex: 1;
}
.line {
  width: 67px;
  height: 2px;
  margin: 0 auto;
  background: #f56446;
}
.active {
  color: #f56446;
}
.LoginTab >>> .van-field__label {
  text-align: left;
}
.LoginTab >>> .van-cell {
  padding: 8px 16px;
}
.tabTip {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #ff6538;
  margin: 16px 0 0 16px;
  text-align: left;
}
</style>
